import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'jquery/dist/jquery.min'
import 'moment/dist/moment'
import 'datatables.net/js/jquery.dataTables.js';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-bs4/js/dataTables.bootstrap4.min.js';
import 'trix/dist/trix';
import 'bootstrap-tagsinput/dist/bootstrap-tagsinput.js';
import 'i18next/dist/umd/i18next';